import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';

interface IProps {
  children: string;
  style?: React.CSSProperties;
}
const InputTitle = ({ children, style }: IProps) => {
  return <Title style={style}>{children}</Title>;
};

export default InputTitle;
const Title = styled.p`
  color: ${theme.colors.blue_7};
  font-size: ${theme.fontSizes.md};
  margin-left: 0.5rem;
`;
